import React from 'react'
import { AiOutlineSearch } from 'react-icons/ai'
import { Form, Transition } from 'semantic-ui-react'
import { ANIMATION_DURATION, MarketOptions, RouteTypeOptionsAwayTrade } from '../constants'
import { CounterPartyDetailsProps } from '../CounterPartyDetails'
import { getError } from '../helpers'
import styles from '../styles.module.less'
import { MarketEnum, RouteTypeEnum } from '../Types'

const DIRECTORY_URL = 'https://otce.finra.org/otce/mp-list'

const AwayTradeFields = ({ setFieldValue, values, handleBlur, errors, touched }: CounterPartyDetailsProps) => (
  <div className={'test-away-trade-form-group'}>
    <Form.Group widths="5">
      <Form.Select
        className={'test-route-type'}
        selection={true}
        required={true}
        label="Route Type"
        name="routeType"
        value={values.routeType}
        options={RouteTypeOptionsAwayTrade}
        error={getError('routeType', errors, touched)}
        onBlur={() => {
          handleBlur('routeType')
        }}
        onChange={(_, data) => {
          setFieldValue('routeType', data.value)
        }}
      />
      <Form.Input
        className={'test-order-id'}
        label="Order ID"
        name="orderId"
        value={values.orderId}
        onChange={(_, data) => {
          setFieldValue('orderId', data.value)
        }}
        onBlur={() => {
          handleBlur('orderId')
        }}
        error={getError('orderId', errors, touched)}
      />
    </Form.Group>
    <Transition.Group animation={'fade down'} duration={ANIMATION_DURATION}>
      {(values.routeType === RouteTypeEnum.Dma || values.routeType === RouteTypeEnum.Away) && (
        <Form.Group widths="5">
          <Form.Select
            className={'test-market'}
            data-testid="test-market"
            selection={true}
            search={true}
            label="Market"
            name="market"
            required
            options={MarketOptions}
            value={values.market || MarketEnum.Otc}
            onChange={(_, data) => {
              setFieldValue('market', data.value)
            }}
          />
        </Form.Group>
      )}
    </Transition.Group>
    <Form.Group widths="5">
      <div className={'field'}>
        <Form.Input
          className={'test-exec-broker'}
          label="Executing Broker (MPID)"
          required={values.routeType === RouteTypeEnum.Away && values.market === MarketEnum.Otc}
          name="executingBroker"
          disabled={values?.market !== MarketEnum.Otc}
          value={values.executingBroker || ''}
          onChange={(_, data) => {
            setFieldValue('executingBroker', data.value)
          }}
          onBlur={() => {
            handleBlur('executingBroker')
          }}
          error={getError('executingBroker', errors, touched)}
        />
        {values?.market === MarketEnum.Otc && (
          <a href={DIRECTORY_URL} className={styles.viewDirectoryLink} target={'_blank'} rel="noopener noreferrer">
            <AiOutlineSearch size={'16px'} /> <span className={styles.viewText}>View Directory</span>
          </a>
        )}
      </div>
    </Form.Group>
  </div>
)

export default AwayTradeFields
